<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12 col-lg-8">
            <h1>
                Comparatif de projets
                <span>Comparez vos différents projets</span>
            </h1>
        </div>
        <div class="col-12 col-lg-4 text-lg-end mt-lg-3" *ngIf="loading == false && favorites.length > 0 && favorites.length < 5">
            <a class="btn" (click)="addFavorite()"><i class="fa fa-plus" aria-hidden="true"></i> Ajouter un projet</a>
        </div>
    </div>
    <div class="row mb-lg-2" *ngIf="loading == false && favorites.length > 1">
        <div class="offset-lg-9 col-lg-3 col-12">
            <mat-form-field class="diffSelect no-label">
                <mat-label>Différences</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="diff" (ngModelChange)="trackingService.click('compare_change_diff',diff);">
                    <mat-option value="-1">Différences : masquées</mat-option>
                    <mat-option value="0">Différences : en valeur</mat-option>
                    <mat-option value="1">Différences : en %</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12" id="compareContent">
            <div class="card">
                <div class="card-body table-card">
                    <div *ngIf="loading == false && favorites.length == 0" class="compare-empty text-center">
                        <p class="mb-4">Aucun projet dans le comparatif pour le moment.<br/>
                            Ajoutez de 2 à 5 projets depuis vos favoris pour les comparer entre eux.</p>
                        <button class="btn" (click)="addFavorite()"
                                [stepContent]="addCompareStepContent"
                                joyrideStep="addCompareStep">
                            <i class="fa fa-plus" aria-hidden="true"></i> Ajouter un projet
                        </button>
                    </div>
                    <div *ngIf="loading == false && favorites.length > 0" class="table-scroll">
                        <table>
                            <thead>
                            <tr>
                                <td class="corner"></td>
                                <th *ngFor="let favorite of favorites;index as i" class="project-col">
                                    <div class="project-tools">
                                        <span *ngIf="i == 0" class="ref-badge">Référence</span>
                                        <i *ngIf="i > 0" (click)="setMain(favorite.id)" class="fa fa-arrow-left"
                                           matTooltip="Définir comme référence"></i>
                                        <i (click)="remove(favorite.id)" class="fa fa-close"
                                           matTooltip="Retirer du comparatif"></i>
                                    </div>
                                    <img class="adPicto" *ngIf="favorite.pictures[0]" src="{{ favorite.pictures[0] }}"
                                         (error)="imageService.changeImg($event)"/>
                                    <div class="adPicto no-photo" *ngIf="!favorite.pictures[0]">
                                        <i class="fa fa-picture-o" aria-hidden="true"></i>
                                    </div>
                                    <p>
                                        {{ favorite.title }}
                                    </p>
                                    <a class="btn btn-outline btn-sm"
                                       [routerLink]="['/app/favorites', favorite.favorite_list.id, favorite.id]">
                                        <i class="fa fa-eye" aria-hidden="true"></i> Ouvrir
                                    </a>
                                </th>
                                <th *ngIf="favorites.length < 5" class="add-col">
                                    <button type="button" class="btn-add-project" (click)="addFavorite()"
                                            [stepContent]="addCompareStepContent"
                                            joyrideStep="addCompareStep">
                                        <i class="fa fa-plus" aria-hidden="true"></i><br/>
                                        Ajouter un projet
                                    </button>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td colspan="6" class="subGroup isMinimizable" data-target="mainKpi">
                                    Indicateurs clés
                                    <i class="fa fa-angle-up"></i>
                                </td>
                            </tr>
                            <tr class="mainKpi">
                                <th>Prix au m² à l'achat</th>
                                <td *ngFor="let favorite of favorites;index as i"
                                    [stepContent]="comparePriceStepContent"
                                    [joyrideStep]="'comparePriceStep' + i">
                                    {{ favorite.price / favorite.square | number:'1.0-1' }} €/m²
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': (favorite.price / favorite.square) < (favorites[0].price / favorites[0].square), 'text-red': (favorite.price / favorite.square) > (favorites[0].price / favorites[0].square)}">
                                   (
                                    <ng-container
                                        *ngIf="(favorite.price / favorite.square) > (favorites[0].price / favorites[0].square)">+</ng-container>
                                        {{ (((favorite.price / favorite.square) / (favorites[0].price / favorites[0].square)) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': (favorite.price / favorite.square) < (favorites[0].price / favorites[0].square), 'text-red': (favorite.price / favorite.square) > (favorites[0].price / favorites[0].square)}">
                                   (
                                    <ng-container
                                        *ngIf="(favorite.price / favorite.square) > (favorites[0].price / favorites[0].square)">+</ng-container>
                                        {{ ((favorite.price / favorite.square) - (favorites[0].price / favorites[0].square)) | number:'1.1-1' }}
                                        €/m²
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="mainKpi">
                                <th>Prix au m² final</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.total_price / favorite.square | number:'1.0-1' }} €/m²
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': (favorite.total_price / favorite.square) < (favorites[0].total_price / favorites[0].square), 'text-red': (favorite.total_price / favorite.square) > (favorites[0].total_price / favorites[0].square)}">
                                   (
                                    <ng-container
                                        *ngIf="(favorite.total_price / favorite.square) > (favorites[0].total_price / favorites[0].square)">+</ng-container>
                                        {{ (((favorite.total_price / favorite.square) / (favorites[0].total_price / favorites[0].square)) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': (favorite.total_price / favorite.square) < (favorites[0].total_price / favorites[0].square), 'text-red': (favorite.total_price / favorite.square) > (favorites[0].total_price / favorites[0].square)}">
                                   (
                                    <ng-container
                                        *ngIf="(favorite.total_price / favorite.square) > (favorites[0].total_price / favorites[0].square)">+</ng-container>
                                        {{ ((favorite.total_price / favorite.square) - (favorites[0].total_price / favorites[0].square)) | number:'1.1-1' }}
                                        €/m²
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="mainKpi">
                                <th>Rendement Brut</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.efficiency_brut | number:'1.1-1' }} %
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-red': favorite.efficiency_brut < favorites[0].efficiency_brut, 'text-green': favorite.efficiency_brut > favorites[0].efficiency_brut}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.efficiency_brut > favorites[0].efficiency_brut">+</ng-container>
                                        {{ ((favorite.efficiency_brut / favorites[0].efficiency_brut) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-red': favorite.efficiency_brut < favorites[0].efficiency_brut, 'text-green': favorite.efficiency_brut > favorites[0].efficiency_brut}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.efficiency_brut > favorites[0].efficiency_brut">+</ng-container>
                                        {{ (favorite.efficiency_brut - favorites[0].efficiency_brut) | number:'1.1-1' }}
                                        %
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="mainKpi">
                                <th>Rendement Net</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.efficiency_net | number:'1.1-1' }} %
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-red': favorite.efficiency_net < favorites[0].efficiency_net, 'text-green': favorite.efficiency_net > favorites[0].efficiency_net}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.efficiency_net > favorites[0].efficiency_net">+</ng-container>
                                        {{ ((favorite.efficiency_net / favorites[0].efficiency_net) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-red': favorite.efficiency_net < favorites[0].efficiency_net, 'text-green': favorite.efficiency_net > favorites[0].efficiency_net}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.efficiency_net > favorites[0].efficiency_net">+</ng-container>
                                        {{ (favorite.efficiency_net - favorites[0].efficiency_net) | number:'1.1-1' }} %
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="mainKpi">
                                <th>Cash-flow mensuel</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.cash_flow  | number:'1.1-1' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-red': favorite.cash_flow < favorites[0].cash_flow, 'text-green': favorite.cash_flow > favorites[0].cash_flow }">
                                   (
                                    <ng-container *ngIf="favorite.cash_flow > favorites[0].cash_flow">+</ng-container>
                                        {{ ((favorite.cash_flow / favorites[0].cash_flow) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-red': favorite.cash_flow < favorites[0].cash_flow, 'text-green': favorite.cash_flow > favorites[0].cash_flow}">
                                   (
                                    <ng-container *ngIf="favorite.cash_flow > favorites[0].cash_flow">+</ng-container>
                                        {{ (favorite.cash_flow - favorites[0].cash_flow) | number:'1.1-1' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="mainKpi">
                                <th>Taux de couverture</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.coverage_rate  | number:'1.1-1' }} %
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.coverage_rate < favorites[0].coverage_rate, 'text-red': favorite.coverage_rate > favorites[0].coverage_rate }">
                                   (
                                    <ng-container
                                        *ngIf="favorite.coverage_rate > favorites[0].coverage_rate">+</ng-container>
                                        {{ ((favorite.coverage_rate / favorites[0].coverage_rate) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.coverage_rate < favorites[0].coverage_rate, 'text-red': favorite.coverage_rate > favorites[0].coverage_rate}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.coverage_rate > favorites[0].coverage_rate">+</ng-container>
                                        {{ (favorite.coverage_rate - favorites[0].coverage_rate) | number:'1.1-1' }} %
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr [stepContent]="achatCompareStepContent"
                                joyrideStep="achatCompareStep">
                                <td colspan="6" class="subGroup isMinimizable minimize" data-target="achat">
                                    Achat
                                    <i class="fa fa-angle-up"></i>
                                </td>
                            </tr>
                            <tr class="achat">
                                <th>Prix de l'annonce</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.ad.price | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.ad.price < favorites[0].ad.price, 'text-red': favorite.ad.price > favorites[0].ad.price}">
                                   (
                                    <ng-container *ngIf="favorite.ad.price > favorites[0].ad.price">+</ng-container>
                                        {{ ((favorite.ad.price / favorites[0].ad.price) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.ad.price < favorites[0].ad.price, 'text-red': favorite.ad.price > favorites[0].ad.price}">
                                   (
                                    <ng-container *ngIf="favorite.ad.price > favorites[0].ad.price">+</ng-container>
                                        {{ (favorite.ad.price - favorites[0].ad.price) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="achat">
                                <th>Montant de l'offre</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.price | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.price < favorites[0].price, 'text-red': favorite.price > favorites[0].price}">
                                   (
                                    <ng-container *ngIf="favorite.price > favorites[0].price">+</ng-container>
                                        {{ ((favorite.price / favorites[0].price) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.price < favorites[0].price, 'text-red': favorite.price > favorites[0].price}">
                                   (
                                    <ng-container *ngIf="favorite.price > favorites[0].price">+</ng-container>
                                        {{ (favorite.price - favorites[0].price) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="achat">
                                <th>Surface</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.square | number:'1.0-0' }} m²
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-red': favorite.square < favorites[0].square, 'text-green': favorite.square > favorites[0].square}">
                                   (
                                    <ng-container *ngIf="favorite.square > favorites[0].square">+</ng-container>
                                        {{ ((favorite.square / favorites[0].square) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-red': favorite.square < favorites[0].square, 'text-green': favorite.square > favorites[0].square}">
                                   (
                                    <ng-container *ngIf="favorite.square > favorites[0].square">+</ng-container>
                                        {{ (favorite.square - favorites[0].square) | number:'1.0-0' }} m²
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="achat">
                                <th>Frais de notaire</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.notary_price | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.notary_price < favorites[0].notary_price, 'text-red': favorite.notary_price > favorites[0].notary_price}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.notary_price > favorites[0].notary_price">+</ng-container>
                                        {{ ((favorite.notary_price / favorites[0].notary_price) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.notary_price < favorites[0].notary_price, 'text-red': favorite.notary_price > favorites[0].notary_price}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.notary_price > favorites[0].notary_price">+</ng-container>
                                        {{ (favorite.notary_price - favorites[0].notary_price) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="achat">
                                <th>Meuble</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.furniture_price | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.furniture_price < favorites[0].furniture_price, 'text-red': favorite.furniture_price > favorites[0].furniture_price}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.furniture_price > favorites[0].furniture_price">+</ng-container>
                                        {{ ((favorite.furniture_price / favorites[0].furniture_price) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.furniture_price < favorites[0].furniture_price, 'text-red': favorite.furniture_price > favorites[0].furniture_price}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.furniture_price > favorites[0].furniture_price">+</ng-container>
                                        {{ (favorite.furniture_price - favorites[0].furniture_price) | number:'1.0-0' }}
                                        €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="achat">
                                <th>Travaux</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.works_total | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.works_total < favorites[0].works_total, 'text-red': favorite.works_total > favorites[0].works_total}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.works_total > favorites[0].works_total">+</ng-container>
                                        {{ ((favorite.works_total / favorites[0].works_total) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.works_total < favorites[0].works_total, 'text-red': favorite.works_total > favorites[0].works_total}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.works_total > favorites[0].works_total">+</ng-container>
                                        {{ (favorite.works_total - favorites[0].works_total) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="achat">
                                <th>Total achat</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.total_price | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.total_price < favorites[0].total_price, 'text-red': favorite.total_price > favorites[0].total_price}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.total_price > favorites[0].total_price">+</ng-container>
                                        {{ ((favorite.total_price / favorites[0].total_price) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.total_price < favorites[0].total_price, 'text-red': favorite.total_price > favorites[0].total_price}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.total_price > favorites[0].total_price">+</ng-container>
                                        {{ (favorite.total_price - favorites[0].total_price) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="subGroup isMinimizable minimize" data-target="credit">
                                    Crédit
                                    <i class="fa fa-angle-up"></i>
                                </td>
                            </tr>
                            <tr class="credit">
                                <th>Apport</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.apport | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.apport < favorites[0].apport, 'text-red': favorite.apport > favorites[0].apport}">
                                   (
                                    <ng-container *ngIf="favorite.apport > favorites[0].apport">+</ng-container>
                                        {{ ((favorite.apport / favorites[0].apport) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.apport < favorites[0].apport, 'text-red': favorite.apport > favorites[0].apport}">
                                   (
                                    <ng-container *ngIf="favorite.apport > favorites[0].apport">+</ng-container>
                                        {{ (favorite.apport - favorites[0].apport) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="credit">
                                <th>Frais</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.deposit_fees | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.deposit_fees < favorites[0].deposit_fees, 'text-red': favorite.deposit_fees > favorites[0].deposit_fees}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.deposit_fees > favorites[0].deposit_fees">+</ng-container>
                                        {{ ((favorite.deposit_fees / favorites[0].deposit_fees) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.deposit_fees < favorites[0].deposit_fees, 'text-red': favorite.deposit_fees > favorites[0].deposit_fees}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.deposit_fees > favorites[0].deposit_fees">+</ng-container>
                                        {{ (favorite.deposit_fees - favorites[0].deposit_fees) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="credit">
                                <th>Taux crédit</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.rate | number:'1.2-2' }} %
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.rate < favorites[0].rate, 'text-red': favorite.rate > favorites[0].rate}">
                                   (
                                    <ng-container *ngIf="favorite.rate > favorites[0].rate">+</ng-container>
                                        {{ ((favorite.rate / favorites[0].rate) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.rate < favorites[0].rate, 'text-red': favorite.rate > favorites[0].rate}">
                                   (
                                    <ng-container *ngIf="favorite.rate > favorites[0].rate">+</ng-container>
                                        {{ (favorite.rate - favorites[0].rate) | number:'1.2-2' }} %
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="credit">
                                <th>Taux assurance</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.rate_insurance | number:'1.2-2' }} %
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.rate_insurance < favorites[0].rate_insurance, 'text-red': favorite.rate_insurance > favorites[0].rate_insurance}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.rate_insurance > favorites[0].rate_insurance">+</ng-container>
                                        {{ ((favorite.rate_insurance / favorites[0].rate_insurance) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.rate_insurance < favorites[0].rate_insurance, 'text-red': favorite.rate_insurance > favorites[0].rate_insurance}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.rate_insurance > favorites[0].rate_insurance">+</ng-container>
                                        {{ (favorite.rate_insurance - favorites[0].rate_insurance) | number:'1.2-2' }} %
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="credit">
                                <th>Durée</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.duration | number:'1.0-0' }} ans
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.duration < favorites[0].duration, 'text-red': favorite.duration > favorites[0].duration}">
                                   (
                                    <ng-container *ngIf="favorite.duration > favorites[0].duration">+</ng-container>
                                        {{ ((favorite.duration / favorites[0].duration) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.duration < favorites[0].duration, 'text-red': favorite.duration > favorites[0].duration}">
                                   (
                                    <ng-container *ngIf="favorite.duration > favorites[0].duration">+</ng-container>
                                        {{ (favorite.duration - favorites[0].duration) | number:'1.0-0' }} ans
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="credit">
                                <th>Mensualité</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.monthly | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.monthly < favorites[0].monthly, 'text-red': favorite.monthly > favorites[0].monthly}">
                                   (
                                    <ng-container *ngIf="favorite.monthly > favorites[0].monthly">+</ng-container>
                                        {{ ((favorite.monthly / favorites[0].monthly) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.monthly < favorites[0].monthly, 'text-red': favorite.monthly > favorites[0].monthly}">
                                   (
                                    <ng-container *ngIf="favorite.monthly > favorites[0].monthly">+</ng-container>
                                        {{ (favorite.monthly - favorites[0].monthly) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="subGroup isMinimizable minimize" data-target="loyers">
                                    Loyers
                                    <i class="fa fa-angle-up"></i>
                                </td>
                            </tr>
                            <tr class="loyers">
                                <th>Loyer</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.amount_rent | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.amount_rent < favorites[0].amount_rent, 'text-red': favorite.amount_rent > favorites[0].amount_rent}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_rent > favorites[0].amount_rent">+</ng-container>
                                        {{ ((favorite.amount_rent / favorites[0].amount_rent) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.amount_rent < favorites[0].amount_rent, 'text-red': favorite.amount_rent > favorites[0].amount_rent}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_rent > favorites[0].amount_rent">+</ng-container>
                                        {{ (favorite.amount_rent - favorites[0].amount_rent) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="subGroup isMinimizable minimize" data-target="charge">
                                    Charges annuelles
                                    <i class="fa fa-angle-up"></i>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Taxe foncière</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.amount_property_tax | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.amount_property_tax < favorites[0].amount_property_tax, 'text-red': favorite.amount_property_tax > favorites[0].amount_property_tax}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_property_tax > favorites[0].amount_property_tax">+</ng-container>
                                        {{ ((favorite.amount_property_tax / favorites[0].amount_property_tax) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.amount_property_tax < favorites[0].amount_property_tax, 'text-red': favorite.amount_property_tax > favorites[0].amount_property_tax}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_property_tax > favorites[0].amount_property_tax">+</ng-container>
                                        {{ (favorite.amount_property_tax - favorites[0].amount_property_tax) | number:'1.0-0' }}
                                        €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Assurance PNO</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.building_insurance | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.building_insurance < favorites[0].building_insurance, 'text-red': favorite.building_insurance > favorites[0].building_insurance}">
                                   (
                                    <ng-container *ngIf="favorite.building_insurance > favorites[0].building_insurance">+</ng-container>
                                        {{ ((favorite.building_insurance / favorites[0].building_insurance) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.building_insurance < favorites[0].building_insurance, 'text-red': favorite.building_insurance > favorites[0].building_insurance}">
                                   (
                                    <ng-container *ngIf="favorite.building_insurance > favorites[0].building_insurance">+</ng-container>
                                        {{ (favorite.building_insurance - favorites[0].building_insurance) | number:'1.0-0' }}
                                        €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Gestion agence</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.agence | number:'1.0-0' }} %
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.agence < favorites[0].agence, 'text-red': favorite.agence > favorites[0].agence}">
                                   (
                                    <ng-container *ngIf="favorite.agence > favorites[0].agence">+</ng-container>
                                        {{ ((favorite.agence / favorites[0].agence) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.agence < favorites[0].agence, 'text-red': favorite.agence > favorites[0].agence}">
                                   (
                                    <ng-container *ngIf="favorite.agence > favorites[0].agence">+</ng-container>
                                        {{ (favorite.agence - favorites[0].agence) | number:'1.0-0' }} %
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Frais de relocation</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.agence_rental | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.agence_rental < favorites[0].agence_rental, 'text-red': favorite.agence_rental > favorites[0].agence_rental}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.agence_rental > favorites[0].agence_rental">+</ng-container>
                                        {{ ((favorite.agence_rental / favorites[0].agence_rental) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.agence_rental < favorites[0].agence_rental, 'text-red': favorite.agence_rental > favorites[0].agence_rental}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.agence_rental > favorites[0].agence_rental">+</ng-container>
                                        {{ (favorite.agence_rental - favorites[0].agence_rental) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>GLI</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.amount_rent_insurance | number:'1.0-0' }} %
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.amount_rent_insurance < favorites[0].amount_rent_insurance, 'text-red': favorite.amount_rent_insurance > favorites[0].amount_rent_insurance}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_rent_insurance > favorites[0].amount_rent_insurance">+</ng-container>
                                        {{ ((favorite.amount_rent_insurance / favorites[0].amount_rent_insurance) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.amount_rent_insurance < favorites[0].amount_rent_insurance, 'text-red': favorite.amount_rent_insurance > favorites[0].amount_rent_insurance}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_rent_insurance > favorites[0].amount_rent_insurance">+</ng-container>
                                        {{ (favorite.amount_rent_insurance - favorites[0].amount_rent_insurance) | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Charges copro</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.amount_copro | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.amount_copro < favorites[0].amount_copro, 'text-red': favorite.amount_copro > favorites[0].amount_copro}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_copro > favorites[0].amount_copro">+</ng-container>
                                        {{ ((favorite.amount_copro / favorites[0].amount_copro) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.amount_copro < favorites[0].amount_copro, 'text-red': favorite.amount_copro > favorites[0].amount_copro}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_copro > favorites[0].amount_copro">+</ng-container>
                                        {{ (favorite.amount_copro - favorites[0].amount_copro) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Charges locataire</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.amount_copro_rent | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.amount_copro_rent < favorites[0].amount_copro_rent, 'text-red': favorite.amount_copro_rent > favorites[0].amount_copro_rent}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_copro_rent > favorites[0].amount_copro_rent">+</ng-container>
                                        {{ ((favorite.amount_copro_rent / favorites[0].amount_copro_rent) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.amount_copro_rent < favorites[0].amount_copro_rent, 'text-red': favorite.amount_copro_rent > favorites[0].amount_copro_rent}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.amount_copro_rent > favorites[0].amount_copro_rent">+</ng-container>
                                        {{ (favorite.amount_copro_rent - favorites[0].amount_copro_rent) | number:'1.0-0' }}
                                        €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Vacance locative</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.rental_vacancy | number:'1.1-1' }} mois
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.rental_vacancy < favorites[0].rental_vacancy, 'text-red': favorite.rental_vacancy > favorites[0].rental_vacancy}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.rental_vacancy > favorites[0].rental_vacancy">+</ng-container>
                                        {{ ((favorite.rental_vacancy / favorites[0].rental_vacancy) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.rental_vacancy < favorites[0].rental_vacancy, 'text-red': favorite.rental_vacancy > favorites[0].rental_vacancy}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.rental_vacancy > favorites[0].rental_vacancy">+</ng-container>
                                        {{ (favorite.rental_vacancy - favorites[0].rental_vacancy) | number:'1.1-1' }}
                                        mois
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Autres frais</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.other_bill | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.other_bill < favorites[0].other_bill, 'text-red': favorite.other_bill > favorites[0].other_bill}">
                                   (
                                    <ng-container *ngIf="favorite.other_bill > favorites[0].other_bill">+</ng-container>
                                        {{ ((favorite.other_bill / favorites[0].other_bill) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.other_bill < favorites[0].other_bill, 'text-red': favorite.other_bill > favorites[0].other_bill}">
                                   (
                                    <ng-container *ngIf="favorite.other_bill > favorites[0].other_bill">+</ng-container>
                                        {{ (favorite.other_bill - favorites[0].other_bill) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Comptabilité</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.accouting_fees | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.accouting_fees < favorites[0].accouting_fees, 'text-red': favorite.accouting_fees > favorites[0].accouting_fees}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.accouting_fees > favorites[0].accouting_fees">+</ng-container>
                                        {{ ((favorite.accouting_fees / favorites[0].accouting_fees) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.accouting_fees < favorites[0].accouting_fees, 'text-red': favorite.accouting_fees > favorites[0].accouting_fees}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.accouting_fees > favorites[0].accouting_fees">+</ng-container>
                                        {{ (favorite.accouting_fees - favorites[0].accouting_fees) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>CFE</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.cfe_contribution | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.cfe_contribution < favorites[0].cfe_contribution, 'text-red': favorite.cfe_contribution > favorites[0].cfe_contribution}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.cfe_contribution > favorites[0].cfe_contribution">+</ng-container>
                                        {{ ((favorite.cfe_contribution / favorites[0].cfe_contribution) - 1) * 100 | number:'1.0-0' }}
                                        %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.cfe_contribution < favorites[0].cfe_contribution, 'text-red': favorite.cfe_contribution > favorites[0].cfe_contribution}">
                                   (
                                    <ng-container
                                        *ngIf="favorite.cfe_contribution > favorites[0].cfe_contribution">+</ng-container>
                                        {{ (favorite.cfe_contribution - favorites[0].cfe_contribution) | number:'1.0-0' }}
                                        €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr class="charge">
                                <th>Total</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.charge | number:'1.0-0' }} €
                                    <span *ngIf="i != 0 && diff == '1'"
                                          [ngClass]="{'text-green': favorite.charge < favorites[0].charge, 'text-red': favorite.charge > favorites[0].charge}">
                                   (
                                    <ng-container *ngIf="favorite.charge > favorites[0].charge">+</ng-container>
                                        {{ ((favorite.charge / favorites[0].charge) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                    <span *ngIf="i != 0 && diff == '0'"
                                          [ngClass]="{'text-green': favorite.charge < favorites[0].charge, 'text-red': favorite.charge > favorites[0].charge}">
                                   (
                                    <ng-container *ngIf="favorite.charge > favorites[0].charge">+</ng-container>
                                        {{ (favorite.charge - favorites[0].charge) | number:'1.0-0' }} €
                                   )
                                </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="subGroup isMinimizable minimize" data-target="impot">
                                    Imposition
                                    <i class="fa fa-angle-up"></i>
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>Régime foncier</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    {{ favorite.fiscal_choice }}
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>(1re année)<br/>Cash-flow annuel</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    <ng-container *ngIf="impots[i]">
                                        {{ impots[i][0].cash_flow | number:'1.0-0' }} €
                                        <span *ngIf="i != 0 && diff == '1'"
                                              [ngClass]="{'text-red': impots[i][0].cash_flow < impots[0][0].cash_flow, 'text-green': impots[i][0].cash_flow > impots[0][0].cash_flow}">
                                           (
                                            <ng-container
                                                *ngIf="impots[i][0].cash_flow > impots[0][0].cash_flow">+</ng-container>
                                            {{ ((impots[i][0].cash_flow / impots[0][0].cash_flow) - 1) * 100 | number:'1.0-0' }}
                                            %
                                           )
                                        </span>
                                        <span *ngIf="i != 0 && diff == '0'"
                                              [ngClass]="{'text-red': impots[i][0].cash_flow < impots[0][0].cash_flow, 'text-green': impots[i][0].cash_flow > impots[0][0].cash_flow}">
                                           (
                                            <ng-container
                                                *ngIf="impots[i][0].cash_flow > impots[0][0].cash_flow">+</ng-container>
                                            {{ (impots[i][0].cash_flow - impots[0][0].cash_flow) | number:'1.0-0' }} €
                                           )
                                        </span>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>(5ème année)<br/>Cash-flow annuel</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    <ng-container *ngIf="impots[i]">
                                        {{ impots[i][4].cash_flow | number:'1.0-0' }} €
                                        <span *ngIf="i != 0 && diff == '1'"
                                              [ngClass]="{'text-red': impots[i][4].cash_flow < impots[0][4].cash_flow, 'text-green': impots[i][4].cash_flow > impots[0][4].cash_flow}">
                                   (
                                    <ng-container
                                        *ngIf="impots[i][4].cash_flow > impots[0][4].cash_flow">+</ng-container>
                                            {{ ((impots[i][4].cash_flow / impots[0][4].cash_flow) - 1) * 100 | number:'1.0-0' }}
                                            %
                                   )
                                </span>
                                        <span *ngIf="i != 0 && diff == '0'"
                                              [ngClass]="{'text-red': impots[i][4].cash_flow < impots[0][4].cash_flow, 'text-green': impots[i][4].cash_flow > impots[0][4].cash_flow}">
                                   (
                                    <ng-container
                                        *ngIf="impots[i][4].cash_flow > impots[0][4].cash_flow">+</ng-container>
                                            {{ (impots[i][4].cash_flow - impots[0][4].cash_flow) | number:'1.0-0' }} €
                                   )
                                </span>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>(10ème année)<br/>Cash-flow annuel</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    <ng-container *ngIf="impots[i]">
                                        {{ impots[i][9].cash_flow | number:'1.0-0' }} €
                                        <span *ngIf="i != 0 && diff == '1'"
                                              [ngClass]="{'text-red': impots[i][9].cash_flow < impots[0][9].cash_flow, 'text-green': impots[i][9].cash_flow > impots[0][9].cash_flow}">
                                   (
                                    <ng-container
                                        *ngIf="impots[i][9].cash_flow > impots[0][9].cash_flow">+</ng-container>
                                            {{ ((impots[i][9].cash_flow / impots[0][9].cash_flow) - 1) * 100 | number:'1.0-0' }}
                                            %
                                   )
                                </span>
                                        <span *ngIf="i != 0 && diff == '0'"
                                              [ngClass]="{'text-red': impots[i][9].cash_flow < impots[0][9].cash_flow, 'text-green': impots[i][9].cash_flow > impots[0][9].cash_flow}">
                                   (
                                    <ng-container
                                        *ngIf="impots[i][9].cash_flow > impots[0][9].cash_flow">+</ng-container>
                                            {{ (impots[i][9].cash_flow - impots[0][9].cash_flow) | number:'1.0-0' }} €
                                   )
                                </span>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>(20ème année)<br/>Cash-flow annuel</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    <ng-container *ngIf="impots[i]">
                                        {{ impots[i][21].cash_flow | number:'1.0-0' }} €
                                        <span *ngIf="i != 0 && diff == '1'"
                                              [ngClass]="{'text-red': impots[i][21].cash_flow < impots[0][21].cash_flow, 'text-green': impots[i][21].cash_flow > impots[0][21].cash_flow}">
                                   (
                                    <ng-container
                                        *ngIf="impots[i][21].cash_flow > impots[0][21].cash_flow">+</ng-container>
                                            {{ ((impots[i][21].cash_flow / impots[0][21].cash_flow) - 1) * 100 | number:'1.0-0' }}
                                            %
                                   )
                                </span>
                                        <span *ngIf="i != 0 && diff == '0'"
                                              [ngClass]="{'text-red': impots[i][21].cash_flow < impots[0][21].cash_flow, 'text-green': impots[i][21].cash_flow > impots[0][21].cash_flow}">
                                   (
                                    <ng-container
                                        *ngIf="impots[i][21].cash_flow > impots[0][21].cash_flow">+</ng-container>
                                            {{ (impots[i][21].cash_flow - impots[0][21].cash_flow) | number:'1.0-0' }} €
                                   )
                                </span>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>TRI</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    <ng-container *ngIf="comparatif[i]">
                                        {{ comparatif[i].TRI * 100 | number:'1.2-2' }}
                                        <span *ngIf="i != 0 && diff == '1'"
                                              [ngClass]="{'text-red': comparatif[i].TRI < comparatif[0].TRI, 'text-green': comparatif[i].TRI > comparatif[0].TRI}">
                                   (
                                    <ng-container *ngIf="comparatif[i].TRI > comparatif[0].TRI">+</ng-container>
                                            {{ ((comparatif[i].TRI / comparatif[0].TRI) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                        <span *ngIf="i != 0 && diff == '0'"
                                              [ngClass]="{'text-red': comparatif[i].TRI < comparatif[0].TRI, 'text-green': comparatif[i].TRI > comparatif[0].TRI}">
                                   (
                                    <ng-container *ngIf="comparatif[i].TRI > comparatif[0].TRI">+</ng-container>
                                            {{ ((comparatif[i].TRI * 100) - (comparatif[0].TRI * 100)) | number:'1.0-0' }}
                                            )
                                </span>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>VAN</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    <ng-container *ngIf="comparatif[i]">
                                        {{ comparatif[i].VAN | number:'1.0-0' }} €
                                        <span *ngIf="i != 0 && diff == '1'"
                                              [ngClass]="{'text-red': comparatif[i].VAN < comparatif[0].VAN, 'text-green': comparatif[i].VAN > comparatif[0].VAN}">
                                   (
                                    <ng-container *ngIf="comparatif[i].VAN > comparatif[0].VAN">+</ng-container>
                                            {{ ((comparatif[i].VAN / comparatif[0].VAN) - 1) * 100 | number:'1.0-0' }} %
                                   )
                                </span>
                                        <span *ngIf="i != 0 && diff == '0'"
                                              [ngClass]="{'text-red': comparatif[i].VAN < comparatif[0].VAN, 'text-green': comparatif[i].VAN > comparatif[0].VAN}">
                                   (
                                    <ng-container *ngIf="comparatif[i].VAN > comparatif[0].VAN">+</ng-container>
                                            {{ (comparatif[i].VAN - comparatif[0].VAN) | number:'1.0-0' }} €
                                   )
                                </span>
                                    </ng-container>
                                </td>
                            </tr>
                            <tr class="impot">
                                <th>Enrichissement</th>
                                <td *ngFor="let favorite of favorites;index as i">
                                    <ng-container *ngIf="comparatif[i]">
                                        {{ comparatif[i].enrichment | number:'1.0-0' }} €
                                        <span *ngIf="i != 0 && diff == '1'"
                                              [ngClass]="{'text-red': comparatif[i].enrichment < comparatif[0].enrichment, 'text-green': comparatif[i].enrichment > comparatif[0].enrichment}">
                                   (
                                    <ng-container
                                        *ngIf="comparatif[i].enrichment > comparatif[0].enrichment">+</ng-container>
                                            {{ ((comparatif[i].enrichment / comparatif[0].enrichment) - 1) * 100 | number:'1.0-0' }}
                                            %
                                   )
                                </span>
                                        <span *ngIf="i != 0 && diff == '0'"
                                              [ngClass]="{'text-red': comparatif[i].enrichment < comparatif[0].enrichment, 'text-green': comparatif[i].enrichment > comparatif[0].enrichment}">
                                   (
                                    <ng-container
                                        *ngIf="comparatif[i].enrichment > comparatif[0].enrichment">+</ng-container>
                                            {{ (comparatif[i].enrichment - comparatif[0].enrichment) | number:'1.0-0' }}
                                            €
                                   )
                                </span>
                                    </ng-container>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                    <mat-spinner color="second" [hidden]="!loading"></mat-spinner>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="introCompareStepContent"
             joyrideStep="introCompareStep"
             stepPosition="center">
</joyrideStep>
<ng-template #introCompareStepContent>
    <div class="user_onboarding_content">
        <h2>Comparer jusqu’à 5 projets entre eux</h2>
        <p>
            Sur cette page, vous aurez accès à un <b>tableau comparatif</b> entre vos projets.<br/>
            <br/>
            Vous pouvez comparer :
        </p>
        <ul>
            <li>De 2 à 5 annonces différentes pour <b>choisir la meilleure</b></li>
            <li>Plusieurs versions d'un même projet (location meublée ou vide, avant/après travaux ...)</li>
        </ul>
    </div>
</ng-template>

<ng-template #addCompareStepContent>
    <div class="user_onboarding_content">
        <h2>Comparer jusqu’à 5 projets entre eux</h2>
        <p>
            Premièrement, vous allez <b>choisir les projets</b> que vous voulez comparer entre eux.<br/>
            <br/>
            Vous pouvez les supprimer et les déplacer dans les colonnes comme vous le souhaitez.
        </p>
    </div>
</ng-template>

<ng-template #comparePriceStepContent>
    <div class="user_onboarding_content">
        <h2>Comparer jusqu’à 5 projets entre eux</h2>
        <p>
            Vous retrouverez ici tous les chiffres clés de vos projets.<br/>
            <br/>
            Le premier projet est celui utilisé comme <b>référence</b> par rapport aux autres.
        </p>
    </div>
</ng-template>

<ng-template #achatCompareStepContent>
    <div class="user_onboarding_content">
        <h2>Faites le meilleur choix</h2>
        <p>
            En cliquant sur chacun de ces menus, vous aurez accès aux autres <b>chiffres de vos projets</b>, qui sont
            classés par catégorie.<br/>
            <br/>
            Ça y est, <b>vous avez fait votre choix</b> ? 🙂
        </p>
    </div>
</ng-template>
